import { SupplierItemAssortmentTag } from '@retail/products/types';
import dayjs from 'dayjs';

/**
 * A tag whose validTo has passed is no longer part of the item's assortment. Removing a
 * persisted tag is expressed by expiring it, so these tags are kept in the payload but
 * must not be given new dates.
 */
export const isExpiredAssortmentTag = (tag: SupplierItemAssortmentTag) =>
  !!tag.validTo && dayjs(tag.validTo).isBefore(dayjs(), 'day');

export const getActiveAssortmentTags = (tags?: SupplierItemAssortmentTag[]) =>
  tags?.filter((tag) => !isExpiredAssortmentTag(tag)) ?? [];
